import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useFaqHook = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/FaqsCollection");
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  return { data, loading, error };
};

export default useFaqHook;
